import React from 'react';
import './Footer.css'; // We will create this file for Footer specific styles

function Footer() {
  return (
    <footer className="footer">
      <div className="container text-center">
        <p>&copy; {new Date().getFullYear()} Astrology & Numerology Platform. All rights reserved.</p>
        <p>Developed by TweeLabs | <a href="https://tweelabs.com" target="_blank" rel="noopener noreferrer">tweelabs.com</a></p>
      </div>
    </footer>
  );
}

export default Footer;
